import PropTypes from 'prop-types';
import ImageViewer from '@/components/atoms/ImageViewer';
import {MultiLanguageFieldGroup} from '@/components/molecules';
import ReviewField from './ReviewField';

const RackFields = ({data}) => (
  <>
    <ReviewField label='Header' value={data?.header} />
    <ReviewField label='Subheader' value={data?.subheader} />
  </>
);

RackFields.propTypes = {
  data: PropTypes.object
};

// Banner Label is a stacked list (one language block per row), unlike the
// side-by-side language columns used for Rack Display content.
const BannerLabelReview = ({languages, bannerText}) => (
  <div
    className='flex flex-col gap-4'
    data-testid='perfect-store-review-banner-text'>
    {languages.map((lang, index) => {
      const data = bannerText?.[lang.code] || {};
      const isLast = index === languages.length - 1;
      return (
        <div key={lang.code} className='flex flex-col gap-2'>
          <div className='rev_lang'>
            <span className='langBold'>Language: {lang.title}</span>
          </div>
          <ReviewField label='Title' value={data?.title} />
          <ReviewField label='Description' value={data?.description} />
          {!isLast && (
            <hr className='mb-2 border-[color:var(--color-border-divider)]' />
          )}
        </div>
      );
    })}
  </div>
);

BannerLabelReview.propTypes = {
  languages: PropTypes.array,
  bannerText: PropTypes.object
};

const PerfectStoreDisplayReview = ({formData = {}, languages = []}) => {
  const displayContent = formData?.displayContent || {};
  const rackDisplays = displayContent?.rackDisplays || [];

  return (
    <div
      className='flex flex-col gap-6'
      data-testid='perfect-store-display-review'>
      <div className='ml-4'>
        <p className='review-section-label mb-3'>Banner Image</p>
        <hr className='mb-2 border-[color:var(--color-border-divider)]' />
        <p className='review_subtitle mb-2'>First Position Image</p>
        {displayContent?.bannerImage?.imageUrl && (
          <ImageViewer
            url={displayContent.bannerImage.imageUrl}
            alt='First Position Image'
          />
        )}
      </div>

      <div className='ml-4'>
        <p className='review-section-label mb-3'>Banner Text</p>
        <hr className='mb-2 border-[color:var(--color-border-divider)]' />
        <BannerLabelReview
          languages={languages}
          bannerText={displayContent?.bannerText}
        />
      </div>

      {rackDisplays.length > 0 && (
        <div className='ml-4 flex flex-col gap-6'>
          <div>
            <p className='review-section-label mb-3'>Rack Display</p>
            <hr className='mb-2 border-[color:var(--color-border-divider)]' />
          </div>
          {rackDisplays.map((rack, index) => (
            <div key={rack.id || index}>
              <p className='review_subtitle mb-2'>Image {index + 1}</p>
              {rack?.image?.imageUrl && (
                <ImageViewer
                  url={rack.image.imageUrl}
                  alt={`Image ${index + 1}`}
                />
              )}
              <hr className='mb-2 mt-3 border-[color:var(--color-border-divider)]' />
              <MultiLanguageFieldGroup
                className='perfect-store-review-language-grid mt-4'
                languages={languages}
                dataTestId={`perfect-store-review-rack-content-${index}`}
                renderField={(lang) => (
                  <RackFields data={rack?.content?.[lang.code]} />
                )}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

PerfectStoreDisplayReview.propTypes = {
  formData: PropTypes.object,
  languages: PropTypes.array
};

export default PerfectStoreDisplayReview;
